// extracted by mini-css-extract-plugin
export default {"cardImage":"SearchSav_cardImage__m+LhX"};